import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { checkFirebaseUserStatus } from '../../firebaseUtils';

const FirebaseStatusIndicator = ({ email }) => {
    const [status, setStatus] = useState('loading'); // 'loading', 'enabled', 'disabled', 'error'

    useEffect(() => {
        let isMounted = true;

        const getStatus = async () => {
            if (!email) {
                if (isMounted) setStatus('disabled');
                return;
            }

            try {
                const exists = await checkFirebaseUserStatus(email);
                if (isMounted) setStatus(exists ? 'enabled' : 'disabled');
            } catch (err) {
                if (isMounted) setStatus('error');
            }
        };

        getStatus();

        return () => {
            isMounted = false;
        };
    }, [email]);

    if (status === 'loading') {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={16} sx={{ color: '#0070D2' }} />
            </Box>
        );
    }

    if (status === 'error') {
        return (
            <Tooltip title="Communication Error">
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="caption" color="error">?</Typography>
                </Box>
            </Tooltip>
        );
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            {status === 'enabled' ? (
                <Tooltip title="Login Access Enabled">
                    <CheckCircleOutlineIcon sx={{ color: '#555', fontSize: 20 }} />
                </Tooltip>
            ) : (
                <Tooltip title="Login Access Inactive">
                    <HighlightOffIcon sx={{ color: '#555', fontSize: 20, opacity: 0.6 }} />
                </Tooltip>
            )}
        </Box>
    );
};

export default FirebaseStatusIndicator;
